module.exports = "/_next/static/images/Frame@2x-7eaaf28ced9b02d8c2726c024c862e32.webp";